import React from "react"
import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import FaqStructuredData from "@/components/FaqStructuredData"
import { plainTextFromChildren } from "@/utils/faq-structured-data"

const getFaqItemsFromChildren = (children, t, faq) => {
  if (!faq) {
    return []
  }

  return React.Children.toArray(children)
    .map(child => {
      if (!React.isValidElement(child)) {
        return null
      }

      const { title, faqKey, schemaAnswer } = child.props

      if (!title && !faqKey) {
        return null
      }

      const question = faqKey ? t(`${faqKey}.question`) : title
      const answer = schemaAnswer ?? plainTextFromChildren(child.props.children)

      return question && answer ? { question, answer } : null
    })
    .filter(Boolean)
}

const Accordion = ({
  title,
  description,
  className,
  fillContainer = "false",
  wide = "true",
  faq = false,
  children,
}) => {
  const { t } = useTranslation()
  const faqSchemaItems = getFaqItemsFromChildren(children, t, faq)

  return (
    <section
      className={`accordion ${className ?? ""} ${
        fillContainer.toLowerCase() === "true"
          ? "accordion--fill-container"
          : "container-fluid"
      }`}
    >
      <div
        className={`accordion__inner col-xs-12 ${
          wide.toLowerCase() === "false"
            ? "col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2"
            : "col-md-offset-1 col-md-10"
        } center-xs mb-10`}
      >
        {title && <h2>{title}</h2>}
        {description && <p className="mb-8 p--lg">{description}</p>}
        {children}
      </div>

      <FaqStructuredData items={faqSchemaItems} />
    </section>
  )
}

export default Accordion
